export default __webpack_public_path__ + "static/media/related.5e853b9c.gif";